<template>
  <PageLayout
    title="Nová reklama"
    :prev="prevRoute"
    :next="true"
    @next="onNext"
    :show-save-draft="false"
  >
    <v-alert type="info" class="mb-8" outlined icon="mdi-information-outline">
      Odhoďte při vytváření kampaně strach. Nic nebudeme publikovat, ani utrácet
      peníze, dokud na konci posledního kroku nepublikujete kampaň stiskem
      tlačítka „Publikovat“.
    </v-alert>

    <ui-box label="Základní informace">
      <v-text-field
        v-model="name"
        label="Název kampaně"
        outlined
        type="text"
        hide-details="auto"
        @input="isValid('name')"
        :error-messages="getValidationsErrors('name')"
      />
    </ui-box>
  </PageLayout>
</template>

<script>
import { sync } from "vuex-pathify"

import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
import validation from "@/mixins/validation"
import { required } from "vuelidate/lib/validators"

export default {
  name: "AdBasics",
  components: {
    PageLayout,
  },
  validations: {
    name: {
      required,
    },
  },
  mixins: [validation],
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...sync("ads/model@", ["name"]),
  },
  data() {
    return {
      validationMessages: {
        name: {
          required: "Toto pole je povinné",
        },
      },
    }
  },
  methods: {
    onNext() {
      if (this.isValidAll()) {
        this.$router.push(this.nextRoute)
      }
    },
  },
}
</script>
